<app-page-template [showParent]="showParent" 
 (clearQueryString)="onClearQueryString()" [config]="pageConfig" (onAdd)="onCreate()" (sortObject)="getSortItems($event)"
  (comparisonObjects)="getComparisonObjects($event)" (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)" (onShowHelpPage)="onShowHelpPage()">


  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-px-4 !tw-py-2">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- fileName -->
        <td>
          <td-value copyToClipboard [value]="item?.fileName"></td-value>
        </td>

        <!-- status -->
        <td>
          <span
            [matTooltip]="
              item?.status
                | enumToText : PhonebookFileProgressStatusTypeEnumValues
            "
          >
            <i [phonebookFileProgressStatusIcon]="item?.status"></i>
          </span>
        </td>

        <!-- phonebookId -->
        <td>
          <td-value copyToClipboard [value]="item?.phonebookId"></td-value>
        </td>

        <!-- phonebookName -->
        <td>
          <td-value copyToClipboard [value]="item?.phonebookName"></td-value>
        </td>

        <!-- progressPercent -->
        <td>
          <span [matTooltip]="item.progressPercent | convertToString">
            <i [progressPercentIcon]="item?.progressPercent"></i>
          </span>
        </td>

        <!-- totalCount -->
        <td>
          <td-value
            type="number"
            copyToClipboard
            [value]="item?.totalCount"
          ></td-value>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
